/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Faq_Q4Inputs */

const en_to_xml_faq_q4 = /** @type {(inputs: To_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the root element customizable?`)
};

const ko_to_xml_faq_q4 = /** @type {(inputs: To_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`루트 요소를 변경할 수 있나요?`)
};

const ja_to_xml_faq_q4 = /** @type {(inputs: To_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルート要素はカスタマイズできますか？`)
};

/**
* | output |
* | --- |
* | "Is the root element customizable?" |
*
* @param {To_Xml_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_faq_q4 = /** @type {((inputs?: To_Xml_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_faq_q4(inputs)
	if (locale === "ko") return ko_to_xml_faq_q4(inputs)
	return ja_to_xml_faq_q4(inputs)
});